import React from "react";
import { createRoot } from "react-dom/client";
import { KatSpinner } from "@amzn/katal-react";
import { MbmProvider } from "@amzn/react-arb-tools";

import App from "./components/App";
import AppInitWrapper from "./components/AppInitWrapper";
import "./logger";
import { getMbmOptions } from "./helpers";
import { detectLocale } from "./i18n/i18nConfig";
import arbManifest from "translations/arbManifest";

// Self-hosted Bootstrap 3 + Font Awesome (replaces the render-blocking CDN <link>s
// that used to be in public/index.html). Bundled through webpack so they ship
// same-origin via CloudFront with immutable-hash caching - no third-party DNS/TLS
// on first paint and no external availability/supply-chain dependency.
import "bootstrap/dist/css/bootstrap.css";
import "font-awesome/css/font-awesome.css";
import "@amzn/katal-components/styles.css";
import "./index.scss";

// Detect and set locale on the HTML element so getMbmOptions picks it up
const locale = detectLocale();
document.documentElement.setAttribute('lang', locale);
console.log('[i18n] Locale:', locale);

const mbmOptions = getMbmOptions(arbManifest);

const container = document.getElementById("root");
const root = createRoot(container!);
root.render(
  <React.StrictMode>
    <MbmProvider {...mbmOptions}>
      <AppInitWrapper>
        <React.Suspense fallback={<KatSpinner size="large" />}>
          <App />
        </React.Suspense>
      </AppInitWrapper>
    </MbmProvider>
  </React.StrictMode>
);
